import styled from "styled-components";
export const StyledList = styled.div `
  display: flex;
  flex-direction: column;
  background: transparent;
`;
//# sourceMappingURL=List.style.js.map